<template>
  <div id="app">
    <!-- <div style="position: absolute; width: 100vw"> -->
    <nav
      class="navbar web-only"
      style="position: absolute; width: 100%"
      
    >
      <!-- <nav class="navbar fixed-top web-only" style="width: 100%; background-color: #fcbf67;"> -->
      <router-link
        to="/"
        class="navbar-brand"
      >
        <!-- <img src="./assets/logo.png" width="30" height="30" alt=""> -->

        <!-- <img v-if="$router.history.current.path == '/2'" src="./assets/img/logo/enginehire logo thin dark blue 1.1 letterpaths.svg" width="" height="55" alt="Enginehire" style="" class="my-1" id='nav-logo'>
          <img v-else src="./assets/img/logo/enginehire logo thin light 1.0 letterpaths.svg" width="" height="55" alt="Enginehire" style="" class="my-1" id='nav-logo'> -->

        <img
          src="./assets/img/logo/momtalkingtomoms_logo1.0_white.svg"
          width=""
          height="85"
          alt="needumom"
          style=""
          class="my-1 px-3"
          id="nav-logo"
        />
      </router-link>
      <!-- <button style="margin-top: 0px; margin-right: 10px; float: right;" class="mylisting-button light-button">Book a Demo</button> -->
      <!-- <div
        v-if="$router.history.current.path !='/contact'"
        class=""
        style="margin-top: -10px; margin-right: 10px;"
      >
        <router-link
          :to="{ name: 'Book Demo' }"
          class="mylisting-button light-button shadow"
        >Book a Demo</router-link>
      </div> -->
      <!-- <a
        href=""
        class="mylisting-button light-button"
        onclick="Calendly.initPopupWidget({url: 'https://calendly.com/enginehire/30min'});return false;"
        >Book a Demo</a
      > -->

      <div
        class="collapse navbar-collapse"
        id="navbarNavAltMarkup"
      >
        <div class="navbar-nav">
          <router-link
            :to="{ name: 'Book Demo' }"
            class="nav-item nav-link"
          >Learn More</router-link>
          <!-- <a
            class="nav-item nav-link"
            href="https://www.google.com/search?authuser=1&q=Enginehire&stick=H4sIAAAAAAAAAONgU1IxqDAxTUxMTjaySDNMMTEzSTO1MqgwMzZKTjEwS0tJBTLSTBexcrnmpWfmpWZkFqUCAOL_WSk1AAAA&mat=CWuSl5VloDTK&ved=2ahUKEwjX45yUmqiAAxW_mYkEHQPkAuUQrMcEegQIDRAH#lrd=0x45aacc28f1d464f5:0x632cd06fde32cf5,1,,,,"
          >Google Reviews</a> -->
          <!-- <a
            class="nav-item nav-link"
            href="#"
          >Get Started</a> -->
          <!-- <router-link
            :to="{ name: 'Get Started' }"
            class="nav-item nav-link"
          >Get Started</router-link> -->
          <a
            class="nav-item nav-link"
            href="https://www.g2.com/products/enginehire/reviews"
            target="_blank"
          >Reviews</a>

          <!-- <router-link
            :to="{ name: 'Backup Care Assistant' }"
            class="nav-item nav-link"
          >Backup Care Assistant</router-link> -->
          <a
            class="nav-item nav-link"
            href="https://learn.enginehire.io/en/knowledge/kb-tickets/new"
            target="_blank"
          >Customer Support</a>
        </div>
      </div>

      <div
        v-if="$router.history.current.path =='/'"
        class=""
        style="margin-top: -55px; margin-right: 10px;"
      >
        <router-link
          :to="{ name: 'Login' }"
          class="mylisting-button dark-button"
        >Login</router-link>
        <!-- <button class="mylisting-button dark-button">
          <a
            href="https://app.momstalkingtomoms.com/login/409"
          >Log In</a>
        </button> -->
      </div>
      <div
        v-else
        class=""
        style="margin-top: -10px; margin-right: 10px;"
      >
        <router-link
          :to="{ name: 'Login' }"
          class="mylisting-button dark-button"
        >Login</router-link>
      </div>
    </nav>
    <!-- </div> -->

    <nav
      class="navbar mobile-only"
      style="position: absolute; width: 100%"
      v-if="$router.history.current.path != '/book-demo'"
    >
      <router-link
        to="/"
        class="navbar-brand"
      >
        <!-- <img src="./assets/logo.png" width="30" height="30" alt=""> -->
        <!-- <img src="./assets/img/logo/enginehire logo thin dark blue 1.1 letterpaths.svg" width="" height="50" alt="Enginehire" style="" id='nav-logo'> -->
        <!-- <img src="./assets/img/logo/enginehire logo thin light 1.0 letterpaths.svg" width="" height="50" alt="Enginehire" style="" id='nav-logo'> -->
        <img
          src="./assets/img/logo/momtalkingtomoms_logo1.0_white.svg"
          width=""
          height="65"
          alt="Moms Talking to Moms"
          style=""
          class="my-1 px-2"
          id="nav-logo"
        />
      </router-link>
      <!-- <button style="margin-top: 5px; margin-right: -5px; float: right;" class="mylisting-button-small light-button">Book a Demo</button> -->
      <!-- <a class="mylisting-button-small light-button shadow" href="https://www.enginehire.io/contact/">Book a Demo</a> -->
      <div
        v-if="$router.history.current.path != '/book-demo'"
        class=""
        style="float: right; margin-top: 14px; margin-right: 14px"
      >
        <router-link
          :to="{ name: 'Login' }"
          class="mylisting-button-small light-button shadow"
        >Log In</router-link>
      </div>
      <!-- <div
        v-if="$router.history.current.path =='/'"
        class=""
        style="margin-top: -10px; margin-right: 10px;"
      >
        <router-link
          :to="{ name: 'Book Demo' }"
          class="mylisting-button dark-button"
        >Login</router-link>
      </div> -->
    </nav>

    <router-view></router-view>

    <!-- <div style="background-color: var(--coredarkcolor); padding-top: 6vh; padding-bottom: 5vh; text-align: center; color: var(--corelightcolor)"> -->
    <!-- <div id="footer" style="background-color: #fcbf67; padding-top: 6vh; padding-bottom: 5vh; text-align: center;">
      <img src="./assets/img/logo/enginehire logo thin dark blue 1.1 letterpaths.svg" width="" height="" alt="Enginehire" style="" id='footer-logo'>
      <h5 style="margin-top: 20px; margin-bottom: 2px; font-weight: 300;">1855 755 4473 | info@enginehire.io</h5>
      <h5 style="margin-top: 5px; font-weight: 300;">Hiring re-engineered.</h5>
    </div> -->

    <!-- <div style="background-color: var(--shopify); padding-top: 6vh; padding-bottom: 5vh; text-align: center;">
      <img src="./assets/img/logo/enginehire logo thin dark 1.0 letterpaths.svg" width="" height="" alt="Enginehire" style="" id='footer-logo'>
      <h5 style="margin-top: 20px; font-weight: 300;">1855 755 4473 | info@enginehire.io</h5>
      <h5 style="margin-top: 10px; font-weight: 300;">Hiring re-engineered.</h5>
    </div> -->

    <app-footer></app-footer>
  </div>
</template>

<script>
import router from "./router";

import Footer from "./components/Footer.vue";

export default {
  name: "app",
  data() {
    return {
      msg: "The digital platform for recruiters and small staffing companies",
    };
  },
  components: {
    AppFooter: Footer,
  },
};
</script>

<style>
:root {
  --coredarkcolor: #702670;
  --corelightcolor: #fff;
  --enginehirelightcolor: #b4c7e7;
  --bootstrapgrey: #e9ecef;
  --skyblue: #bfe7ff;
  /* --skyblue: #ffe6ee; */
  --shopify: #ffefd2;
}

#app {
  font-family: "Quicksand", "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  color: var(--coredarkcolor);
  /* margin-top: 60px; */
}

.center {
  text-align: center;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.top-level-div {
  padding-bottom: 20vh;
  padding-top: 15vh;
}

h1,
h2 {
  font-weight: normal;
}

h4 {
  line-height: 1.5;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
  color: white;
  text-decoration: none;
}

/* --------- BUTTONS --------- */

a:hover {
  text-decoration: none;
}
.mylisting-button {
  /* min-width: 165px; */
  font-family: "articulatcf-demibold", "Montserrat";
  font-weight: 800;
  /* margin-top: 20px; */
  padding: 13px 25px;
  border-radius: 3px;
  font-size: 15px;
  /* height: 48px; */
  -webkit-box-align: center;
  align-items: center;
  position: relative;
  z-index: 0;
  -webkit-box-pack: center;
  justify-content: center;
  white-space: nowrap;
  font-weight: 700;
  border: none;
  margin-top: 10px;
  /* background-size: 200% 100%;
  background-position: right bottom;
  transition: all .25s ease-out; */

  cursor: pointer;
}
.mylisting-button-small {
  /* min-width: 125px; */
  font-family: "articulatcf-demibold", "Montserrat";
  font-weight: 800;
  /* margin-top: 20px; */
  padding: 11px 16px;
  border-radius: 2px;
  font-size: 13px;
  /* height: 48px; */
  -webkit-box-align: center;
  align-items: center;
  text-align: center;
  position: relative;
  z-index: 0;
  -webkit-box-pack: center;
  justify-content: center;
  white-space: nowrap;
  font-weight: 700;
  border: none;
  /* margin-top: 10px; */
  /* background-size: 200% 100%;
  background-position: right bottom;
  transition: all .25s ease-out; */

  cursor: pointer;
}

.dark-button {
  /* background: #6c1cff; */
  /* padding: 0 25px; */
  /* display: flex; */
  /* width: 100%; */

  color: #fff;

  /* border-radius: 3px;
  font-size: 14px;
  height: 48px;
  -webkit-box-align: center;
  align-items: center;
  position: relative;
  z-index: 0;
  -webkit-box-pack: center;
  justify-content: center;
  white-space: nowrap;
  font-weight: 700;
  border: none;
  margin-top: 10px; */

  /* Add a shadow over the search button left to right when you hover over it */
  /* https://codepen.io/kay8/pen/azKbjN */
  /* https://stackoverflow.com/questions/17212094/fill-background-color-left-to-right-css */
  background: linear-gradient(to right, #173754 50%, var(--coredarkcolor) 50%);
  background-size: 200% 100%;
  background-position: right bottom;
  transition: all 0.25s ease-out;
}
.dark-button:hover {
  color: #fff;
  background-position: left bottom;
}

.light-button {
  color: #1f4e78;
  background: linear-gradient(to right, var(--skyblue) 50%, white 50%);
  background-size: 200% 100%;
  background-position: right bottom;
  transition: all 0.25s ease-out;
}
.light-button:hover {
  color: #1f4e78;
  background-position: left bottom;
}

.secondary-button {
  /* color: #fff; */
  color: var(--coredarkcolor);
  background: linear-gradient(to right, #4d4d4d 50%, var(--thrivehiregrey) 50%);
  background-size: 200% 100%;
  background-position: right bottom;
  transition: all 0.25s ease-out;
}
.secondary-button:hover {
  color: #fff;
  background-position: left bottom;
}

.danger-button {
  color: #fff;
  background: linear-gradient(to right, #cc0000 50%, red 50%);
  background-size: 200% 100%;
  background-position: right bottom;
  transition: all 0.25s ease-out;
}
.danger-button:hover {
  color: #fff;
  background-position: left bottom;
}
/* --------------------- */

/* --------- FOOTER --------- */

#footer-logo {
  height: 70px;
}

/* --------------------- */

.mobile-only {
  display: none;
}

/* ------------------- SMALL -------------------- */
@media (max-width: 768px) {
  .mobile-only {
    display: inherit;
  }
  .web-only {
    display: none;
  }

  /* ---- NAVBAR ---- */
  /* .landing .dropdown-item {
    color: var(--coredarkcolor);
    font-size: 13px;
  }

  .navbar {
    padding-left: 0;
    padding-right: 0;
  }
  #nav-logo {
    height: 60px;
  } */
  /* ------- */

  /* h1 {
    font-size: 2rem;
    line-height: 1.1;
  } */

  /* https://laracasts.com/discuss/channels/vue/vue-modal-make-it-scrollable-instead-of-background */
  /* Restrict the height of modals so that they are fully visible on mobile */
  .v--modal-overlay.scrollable .v--modal-box {
    max-height: 80vh;
    overflow-y: auto;
  }

  /* --------- FOOTER --------- */

  #footer-logo {
    height: 60px;
  }

  /* --------------------- */
}

.VueCarousel-slide {
  padding: 20px 0;
}

.VueCarousel-navigation-button {
  border-radius: 50%;
  border: solid 0px #1f4e78 !important;
  width: 42px;
  height: 42px;
  margin-top: -35px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue